<template>
  <CCol class="audienceList">
    <CRow
      v-for="(item, index) in payload"
      :key="'column-'+index"
      :id="'column-'+index"
      class="audienceList__item mb-4">

      <AudienceListColumn :column="item" :optionsTypes="options" />

      <AudienceListColumnProperty :property="item" :types="knowGroup" />

    </CRow>
  </CCol>
</template>

<script>
import AudienceListColumn from "../organize/AudienceList__Column"
import AudienceListColumnProperty from "../organize/AudienceList__ColumnProperty"
export default {
  name: 'AudienceList',
  components: {
    AudienceListColumn,
    AudienceListColumnProperty
  },
  props: {
    payload : {
      type: Array,
      required: true
    },
    options: {
      type : Array,
      required: true
    }
  },
  computed: {
    knowGroup(){
      let arr = this.options.filter((item) => item.group == "default")

      if(!arr.length) {
        return []
      }

      arr = arr[0].values.map(item => {
        return item.value
      })

      return arr
    },
  },
};
</script>
